const REMEMBER_EMAIL_KEY = 'bloop_remember_email'
const REMEMBER_ENABLED_KEY = 'bloop_remember_enabled'

type RememberMeData = {
  email: string
  remember: boolean
}

const safeGetItem = (key: string): string | null => {
  try {
    return localStorage.getItem(key)
  } catch (error) {
    console.warn('[RememberMe] Failed to read localStorage key:', key, error)
    return null
  }
}

const safeSetItem = (key: string, value: string) => {
  try {
    localStorage.setItem(key, value)
  } catch (error) {
    console.warn('[RememberMe] Failed to write localStorage key:', key, error)
  }
}

const safeRemoveItem = (key: string) => {
  try {
    localStorage.removeItem(key)
  } catch (error) {
    console.warn('[RememberMe] Failed to remove localStorage key:', key, error)
  }
}

const isRememberEnabled = (value: string | null): boolean =>
  value === '1' || value === 'true'

export const rememberMeStorage = {
  load(): RememberMeData {
    const email = safeGetItem(REMEMBER_EMAIL_KEY) || ''
    const remember = isRememberEnabled(safeGetItem(REMEMBER_ENABLED_KEY)) && !!email

    return {
      email,
      remember
    }
  },

  save(email: string) {
    const normalizedEmail = email.trim()
    if (!normalizedEmail) {
      this.clear()
      return
    }

    safeSetItem(REMEMBER_EMAIL_KEY, normalizedEmail)
    safeSetItem(REMEMBER_ENABLED_KEY, '1')
  },

  clear() {
    safeRemoveItem(REMEMBER_EMAIL_KEY)
    safeRemoveItem(REMEMBER_ENABLED_KEY)
  }
}
